//
export default function Banner({ title }) {
  return (
    <div className="flex gap-x-6 py-2 items-center bg-highlight px-2.5 sticky top-20 text-white z-20">
      <div className="flex-1 flex justify-center items-center">
        Due to Amazon&apos;s new login requirements for review data access, we've
        paused our Amazon review services.
      </div>
    </div>
  )
}
